var Backbone, EmailFormUSLocationListElementView, EmailFormUSLocationListRowView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormUSLocationListElementView = require("./location_list_element_view");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListRowView = (function(superClass) {
  extend(EmailFormUSLocationListRowView, superClass);

  function EmailFormUSLocationListRowView() {
    return EmailFormUSLocationListRowView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListRowView.prototype.tagName = 'tr';

  EmailFormUSLocationListRowView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationListRowView.prototype.render = function() {
    var element, elements, i, len, locationView, results;
    elements = this.options.elements;
    results = [];
    for (i = 0, len = elements.length; i < len; i++) {
      element = elements[i];
      locationView = new EmailFormUSLocationListElementView({
        location: element
      });
      this.$el.append(locationView.el);
      results.push(locationView.render());
    }
    return results;
  };

  return EmailFormUSLocationListRowView;

})(Backbone.View);

module.exports = EmailFormUSLocationListRowView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9sb2NhdGlvbl9saXN0X3Jvd192aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX2Zvcm0vVVMvbG9jYXRpb25fbGlzdF9yb3dfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw0RUFBQTtFQUFBOzs7QUFBQSxrQ0FBQSxHQUFxQyxPQUFBLENBQVEsOEJBQVI7O0FBQ3JDLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7OzJDQUNKLE9BQUEsR0FBUzs7MkNBRVQsVUFBQSxHQUFZLFNBQUMsT0FBRDtJQUNWLElBQUMsQ0FBQSxPQUFELEdBQVcsT0FBQSxJQUFXO0lBQ3RCLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixDQUFDLENBQUMsT0FBTyxDQUFDLEtBQVYsQ0FBZ0IsQ0FBaEIsRUFBbUIsQ0FBQyxJQUFELENBQU0sQ0FBQyxNQUFQLENBQWMsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxJQUFaLENBQWQsQ0FBbkI7RUFIVTs7MkNBS1osTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsUUFBQSxHQUFXLElBQUMsQ0FBQSxPQUFPLENBQUM7QUFDcEI7U0FBQSwwQ0FBQTs7TUFDRSxZQUFBLEdBQWUsSUFBSSxrQ0FBSixDQUNiO1FBQUEsUUFBQSxFQUFVLE9BQVY7T0FEYTtNQUVmLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLFlBQVksQ0FBQyxFQUF6QjttQkFDQSxZQUFZLENBQUMsTUFBYixDQUFBO0FBSkY7O0VBRk07Ozs7R0FSbUMsUUFBUSxDQUFDOztBQWdCdEQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
